import React from 'react'
import styled from '@emotion/styled'
import { fontWeight, spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'
import LoadingDots from 'legacy/components/LoadingDots'

const StyledContainer = styled.div({
  paddingTop: spacing.X64,
  textAlign: 'center',

  '.header': {
    fontWeight: fontWeight.SEMIBOLD,
    margin: spacing.X20,
  },
})

export const accountUpdateLoadingTestId = 'account-update-loading'

export const AccountUpdateLoading = () => {
  const messages = useDomainMessages({
    header: 'accountManagementDomain.update.loading.header',
    content: 'accountManagementDomain.update.loading.content',
  })

  return (
    <StyledContainer data-testid={accountUpdateLoadingTestId}>
      <LoadingDots height={10} />
      <div className="header">{messages.header}</div>
      <div className="content">{messages.content}</div>
    </StyledContainer>
  )
}
